// เชิญประชุม: ลดทุน (Capital Reduction)

import React from "react";
import PrintField from "../../shared/PrintField";
import "./MeetingforCapitalReduction.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const MeetingforCapitalReduction = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      {/* ref ต้องเกาะที่ A4 */}
      <div className="inv-paper" ref={ref}>
        {/* Header right */}
        <div className="inv-header-right">
          <div className="inv-bold">
            บริษัท{" "}
            <InputField
              className="inv-line inv-line-long"
              style={{ width: "200px" }}
              spellCheck={false}
            />
          </div>

          <div className="inv-header-date inv-bold">
            วันที่{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-short"
              style={{ width: "60px" }}
              spellCheck={false}
            />
          </div>
        </div>

        <div className="inv-body">
          <div className="inv-row">
            <span className="inv-bold">
              เรื่อง&nbsp;&nbsp;เชิญประชุมสามัญผู้ถือหุ้นประจำปี ครั้งที่
            </span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
            />{" "}
            /
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
            />
          </div>

          {/* เรียน */}
          <div className="inv-row inv-row-learn inv-bold">
            เรียน&nbsp;&nbsp;ท่านผู้ถือหุ้น{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "140px" }}
              spellCheck={false}
            />
          </div>

          {/* เนื้อหา */}
          <p className="inv-paragraph">
            ด้วยที่ประชุมคณะกรรมการบริษัท{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "160px" }}
              spellCheck={false}
            />{" "}
            มีมติให้เรียกประชุมวิสามัญผู้ถือหุ้น
            
            ครั้งที่{" "}
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />
            <span className="inv-sep">/</span>
            <InputField
              className="inv-line inv-line-tiny"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            ในวันที่{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "40px" }}
              spellCheck={false}
            />{" "}
            เดือน{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "70px" }}
              spellCheck={false}
            />{" "}
            ปี{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "60px" }}
              spellCheck={false}
            />{" "}
            เวลา{" "}
            <InputField
              className="inv-line inv-line-date"
              style={{ width: "50px" }}
              spellCheck={false}
            />{" "}
            น.
            
            ณ สำนักงานของบริษัทเลขที่{" "}
             <InputField
              className="inv-line inv-line-long"
              style={{ width: "140px" }}
            />
            โดยมีระเบียบวาระการประชุมดังนี้ คือ
          </p>

          {/* วาระประชุม (ลดทุน) */}
          <div className="inv-agenda">
            <div className="inv-agenda-item">
              วาระที่ 1 พิจารณาอนุมัติพิเศษให้ลดทุนของบริษัท
            </div>           

            <div className="inv-agenda-item">
              วาระที่ 2 พิจารณาแก้ไขเพิ่มเติมหนังสือบริคณห์สนธิ ข้อ.5 (ทุน)
            </div>            

            <div className="inv-agenda-item">
              วาระที่ 3 พิจารณาเรื่องอื่นๆ ถ้ามี
            </div>
          </div>

          {/* ปิดท้าย */}
          <p className="inv-paragraph">
            ดังนั้น จึงขอเรียนเชิญท่านผู้ถือหุ้นไปประชุมตามวัน เวลา และสถานที่ดังกล่าวข้างต้น
            โดยพร้อมเพียงกันด้วย จักขอบคุณยิ่ง
          </p>

          {/* ลายเซ็น */}
          <div className="inv-footer">
            <div className="inv-footer-text">ขอแสดงความนับถือ</div>

            <div className="inv-sign-block">
              <InputField className="inv-sign-line" spellCheck={false} optional />
              <div className="inv-sign-name">
                ( <InputField className="inv-sign-name-field" printFit optional={false} /> )
              </div>
              <div className="inv-sign-role">กรรมการ</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default MeetingforCapitalReduction;
